<template>
    <modal name="hello-world" v-bind:class="{ heightPopuo: isActive }" :resizable="true" :reset="true" height="74.4%" width="50%" :minHeight=300 :minWidth=600 :maxHeight=900 :maxWidth=1200 :pivotX=0.5 :pivotY=0.5 :root="true">
        <div class="row  pppp" v-show="videoContent">
            <div class="md-dialog-container" tabindex="-1">
                <div class="boxes videoHeightWrapper" tabindex="-1">
                    <video ref="videoRef" v-bind:src="this.videoSrc" id="video-container" width="100%" controls></video>
                </div>
            </div>
        </div>
        <div class="row" v-show="pdfContent">
            <div class="md-dialog-container" tabindex="-1">
                <div class="boxes" tabindex="-1">
                    <embed v-bind:src="this.videoSrc" width="100%" height="800" alt="pdf" style="height:700px;">
                </div>
            </div>
        </div>
        <div class="row" v-show="faqContent">
            <div class="md-dialog-container" tabindex="-1">
                <div class="boxes" tabindex="-1">
                    <embed v-bind:src="this.videoSrc" width="100%" height="800" alt="pdf" style="height:700px;">
                </div>
            </div>
        </div>
    </modal>
</template>
<script type="text/javascript">
import {getUserManualById} from '../../services/ClientService.js';

export default {
  data: () => ({
    showDeleteDialog: true,
    videoSrc: '',
    fileName: '',
    videoContent: false,
    pdfContent: false,
    faqContent: false,
    userManualId: '',
    isActive: ''
  }),
  methods: {},
  mounted () {
    if (this.$route.path === '/usermanual/pdf') {
      this.pdfContent = true;
      this.videoContent = false;
      this.faqContent = false;
    } else if (this.$route.path === '/usermanual/video') {
      this.videoContent = true;
      this.pdfContent = false;
      this.faqContent = false;
    } else {
      this.videoContent = false;
      this.pdfContent = false;
      this.faqContent = true;
    }
    this.fileName = this.$route.fullPath;
    this.fileName = this.fileName.split('?');
    let url = this;
    this.isActive = '100% importent';
    getUserManualById(this.fileName[1]).then(function (responce) {
      url.videoSrc = responce.data[0].path;
      document.title = responce.data[0].attachment_name;
      url.$modal.show('hello-world');
    });
  }
};
</script>

<style scoped type="scss">
.v--modal-overlay .v--modal-box {
    background: transparent;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 300px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: transparent;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-body {
    margin: 20px 0;
}

.modal-default-button {
    float: right;
}

.boxes.videoHeightWrapper {
    display: flex;
    justify-content: center;
}

.videoHeightWrapper > video {
    /* min-height: 480px; */
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    border: 0;
    left: 0;
    right: 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/user/PlayVideoPdf.vue